import { render, staticRenderFns } from "./LabVaporPressureOfWater.vue?vue&type=template&id=10035476&"
import script from "./LabVaporPressureOfWater.vue?vue&type=script&lang=ts&"
export * from "./LabVaporPressureOfWater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports